'use client'
import { Icon, Image } from '@/components'
import { StyledPaginationSwiper } from '@/components/common/swiper'
import Link from '@/features/ref/components/Link'
import { useWishlistStore } from '@/store'
import { getVND } from '@/utils/helpers'
import { Box, Card, CardProps, IconButton, Stack, styled, Typography } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { motion } from 'framer-motion'
import debounce from 'lodash/debounce'
import { useTranslations } from 'next-intl'
import { useId, useMemo, useRef, useState } from 'react'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
type Props = {
  cardProps?: Omit<CardProps, 'children'>
  product?: ProductComming
}

// Component ProductCard dựa trên thiết kế Figma
export const ProductItemComming = ({ cardProps, product }: Props) => {
  return (
    <Card
      {...cardProps}
      sx={{
        minWidth: { xs: 280, sm: 300, md: 320 },
        borderRadius: 2,
        overflow: 'visible',
        boxShadow: 'none',
        backgroundColor: 'transparent',
        ...cardProps?.sx,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      {/* Main product image container */}
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          aspectRatio: '1/1',
          borderRadius: 2,
          overflow: 'hidden',
          mb: 2,
        }}
      >
        <Image
          src={product?.image as any}
          alt=""
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
        <Box
          component={'span'}
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            backdropFilter: 'blur(22px)',
            zIndex: 1,
          }}
        ></Box>
      </Box>

      {/* Product details */}
      <Box sx={{ px: 0, cursor: 'grab', flex: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box
          sx={{
            p: '.4em 1em',
            borderRadius: '100rem',
            backgroundColor: 'primary.main',
            width: 'fit-content',
            color: '#fff',
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
          }}
        >
          COMING SOON
        </Box>
        <Typography
          sx={{
            fontSize: { xs: '0.875rem', md: '1.125rem' },
            fontWeight: 600,
            lineHeight: 1.5,
            mb: 0.5,
          }}
        >
          {product?.name}
        </Typography>
        {/* <Typography
          sx={{
            mt: 'auto',
            fontSize: { xs: '0.875rem', md: '1.125rem' },
            fontWeight: 100,
          }}
        >
          <Box component={'span'} fontWeight={700}>
            ???.???Đ
          </Box>{' '}
          <Box component={'span'} sx={{ color: '#9B9A99', fontSize: '.8em' }}>
            ???.???Đ
          </Box>{' '}
        </Typography> */}
      </Box>
    </Card>
  )
}
